import CommonDocument from '@/modules/common/hiring/models/MID/CommonDocument'
import CommonPaymentMeans from '@/modules/common/hiring/models/MID/CommonPaymentMeans'
import CommonHiringRecovered from '@/modules/common/hiring/models/MID/CommonHiringRecovered'
import CommonRecoveryMediator from '@/modules/common/hiring/models/MID/CommonRecoveryMediator'

import PetsInsured from '@/modules/pets/hiring/models/MID/PetsInsured'
import PetsPolicyHolder from '@/modules/pets/hiring/models/MID/PetsPolicyHolderRecovered'
import PetsHiringInsuredRecovery from '../../APP/PetsHiringInsuredRecovery'
import type { PetsInsuredCivilLiabilityToSave } from '../PetsInsuredCivilLiabilityToSave'

export default class PetsGetRecoveryResponse {
  /** (GUID): Identificador de la cotización. */
  quotationId!: string

  /** Objeto que contiene información sobre la contratación. */
  hiring!: CommonHiringRecovered

  /** Objeto que contiene información sobre el titular de la póliza. */
  policyHolder!: PetsPolicyHolder

  insuredsPets!: PetsHiringInsuredRecovery[]

  /** (obligatorio, array): Lista de asegurados de Responsabilidad Civil a guardar. Aunque sea una lista, solo se esperará un asegurado, ya que, a día de hoy, aunque haya varias mascotas aseguradas, la responsabilidad civil de todas ellas irá asociada a un único asegurado de RC. Cuando el titular coincide con el asegurado de RC solo será obligatorio informar el campo isPolicyHolder a True y no se tendrá en cuenta el resto de campos */
  insureds!: PetsInsuredCivilLiabilityToSave[]

  /** Lista de objetos que contienen información sobre los documentos asociados. */
  documents!: CommonDocument[]

  /** Objeto que contiene información sobre los medios de pago. */
  paymentMeans!: CommonPaymentMeans | null

  /** Objeto que contiene información sobre el mediador. */
  mediator: CommonRecoveryMediator | null = null

  constructor(data: any) {
    this.quotationId = data.quotationId
    if (data.hiring) this.hiring = new CommonHiringRecovered(data.hiring)
    if (data.policyHolder) this.policyHolder = new PetsPolicyHolder(data.policyHolder)
    this.insureds = data.insureds?.map((insured: any) => new PetsInsured(insured)) ?? []
    this.documents = data.documents?.map((doc: any) => new CommonDocument(doc)) ?? []
    if (data.paymentMeans) this.paymentMeans = new CommonPaymentMeans(data.paymentMeans)
    this.insuredsPets = data.insuredsPets?.map((p: any) => new PetsHiringInsuredRecovery(p)) ?? []
    this.mediator = data.mediator ? new CommonRecoveryMediator(data.mediator) : null
  }
}
